import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import type { BillingSystemFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<BillingSystemFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormInput
          formItemClassName="col-span-12"
          label="Billing System (required)"
          {...field}
          disabled={!isEditable}
          autoFocus={autoFocus}
        />
      )}
    />
  );
}
